import React from "react";
import { Col, Row } from "react-bootstrap";
import Mp4Src from "assets/vidoes/sample-mp4-file.mp4";
import { Controller } from "react-hook-form";
import SrcWithTilte from "../../SrcWithTilte";
import { FormStepsProps } from "../FormStepsProps";
import CustomImageController from "./CustomImageController";

const VideoAndCroppingFormSection = ({
  currStep,
  control,
  errors,
  canvasImages,
  setCanvasImages,
  currentCroppedButton,
  setCurrentCroppedButton,
  addCroppedImageArray,
  setAddCroppedImageArray,
  setValue,
  setError,
  reportOffenceStartTime,
}: FormStepsProps) => {
  return (
    <div className="VideoAndCropping-section-container">
      <Controller
        name="reportVideo"
        control={control}
        render={({ field: { onChange, value } }) => (
          <SrcWithTilte
            setCanvasImages={setCanvasImages}
            currStep={currStep}
            icon
            hasVideo
            src={value}
            currentCroppedButton={currentCroppedButton}
            setAddCroppedImageArray={setAddCroppedImageArray}
            reportOffenceStartTime={reportOffenceStartTime}
          />
        )}
      />
      <section className="cuttedImage-section">
        <Row>
          {addCroppedImageArray
            .filter((cropped) => cropped.name !== "roadProblemPicture")
            .map((image) => {
              return (
                <Col md={4} key={image.name}>
                  <CustomImageController
                    name={image.name}
                    control={control}
                    image={image}
                    setError={setError}
                    setValue={setValue}
                    canvasImages={canvasImages[image.name]}
                    setCurrentCroppedButton={setCurrentCroppedButton}
                    currentCroppedButton={currentCroppedButton}
                    errors={errors}
                    addCroppedImageArray={addCroppedImageArray}
                  />
                </Col>
              );
            })}
        </Row>
      </section>
    </div>
  );
};
export default VideoAndCroppingFormSection;
